<template lang="html">

  <section class="cover-popup row-center" >
    <div class="popup column-center">
      <h2>Asignar tutor acádemico</h2>
      
      <article class="group">

        <h3 class="group-title" :style="styles.colorBasic">Para asignar o modificar el Tutor Académico para esta práctica, seleccione uno a continuación y haga clic en "Guardar asignación".</h3>

        <div class="contenedor-data">
          <h4 class="data-title" :style="styles.colorBasic">Tutor acádemico</h4>
          <div class="contenedor-input">
            <!-- <input type="text" :style="styles.input_black" v-model="tutorSeleccionado"> -->
            <select name="tutor" v-model="tutorSeleccionado" v-validate="'required'" :style="styles.input_black">
              <option value="-1">-selecciona un tutor-</option>
              <option v-for="(el, key) in tutores" :value="el.idTutorAcademico">{{el.nombre}} {{el.apellidos}}
              </option>
            </select>
          </div>
        </div>

        <div class="contenedor-data"></div>
        
        <a class="btn -xs" :style="styles.solidPrimary" @click="guardarAsignacion">Guardar asignación</a>
        
        <h3 class="group-title" :style="styles.colorBasic">Si el/la tutor/a que sea asignar no está en el listado, cumplimente el formulario a continuación. Los campos marcados con * son obligatorios.</h3>

        <div class="contenedor-data">
          <h4 class="data-title" :style="styles.colorBasic">Nombre*</h4>
          <div class="contenedor-input">
            <input type="text" :style="styles.input_black" v-model="nuevoTutor.nombre">
          </div>
        </div>

        <div class="contenedor-data">
          <h4 class="data-title" :style="styles.colorBasic">Apellidos*</h4>
          <div class="contenedor-input">
            <input type="text" :style="styles.input_black" v-model="nuevoTutor.apellidos">
          </div>
        </div>

        <div class="contenedor-data">
          <h4 class="data-title" :style="styles.colorBasic">{{brand.detallePractica.pestannaEstudiante.lblEmailPopupAsignarTutor}}*</h4>
          <div class="contenedor-input">
            <input type="text" :style="styles.input_black" v-model="nuevoTutor.email">
          </div>
        </div>

        <div class="contenedor-data">
          <h4 class="data-title" :style="styles.colorBasic">Teléfono</h4>
          <div class="contenedor-input">
            <input type="text" :style="styles.input_black" v-model="nuevoTutor.telefono">
          </div>
        </div>

        <div class="contenedor-data">
          <h4 class="data-title" :style="styles.colorBasic">DNI</h4>
          <div class="contenedor-input">
            <input type="text" :style="styles.input_black" v-model="nuevoTutor.dni">
          </div>
        </div>

        <div class="contenedor-data"></div>

        <a class="btn -xs" :style="styles.solidPrimary" @click="guardarNuevoTutor">Guardar nuevo tutor</a>
        <a class="btn -xs" :style="styles.solidPrimary" @click="cerrar">Cancelar</a>
        
      </article>
      
    </div>
  </section>

</template>

<script lang="js">

  import { mapGetters, mapActions } from 'vuex';

  export default {
    name: 'popup-encuestas-obligatorias',
    props : ['idPractica'],
    data() {
      return {
        tutorSeleccionado: -1,
        nuevoTutor: {
          idPractica: null,
          nombre: "",
          apellidos: "",
          email: "",
          telefono: "",
          dni: ""
        },
        tutores: []
      }
    },
    mounted() {
      setTimeout(e => {
        this.requestPosiblesTutoresPractica(this.idPractica).then(r => {
          this.tutores = r;
        })
      }, 200)
    },
    computed: {
      ...mapGetters({
        styles: 'getStyles',
        brand : 'getBrand'
      })
    },
    methods: {
      ...mapActions(['requestPosiblesTutoresPractica', 'cambiarTutorAcademicoPractica', 'guardarNuevoTutorAcademicoPractica']),
      cerrar : function(){
        this.$emit('cerrar');
      },
      guardarAsignacion : function(){
        if (this.tutorSeleccionado != -1) {
          this.cambiarTutorAcademicoPractica({ idPractica: this.idPractica, idTutor: this.tutorSeleccionado }).then(r => {
            if (r){
              this.cerrar();
              this.$emit('recargarPractica');
            }
          })
        }
      },
      guardarNuevoTutor : function(){
        if (this.nuevoTutor.nombre != "" && this.nuevoTutor.apellidos != "" && this.nuevoTutor.email != "") {
          this.nuevoTutor.idPractica = this.idPractica;
          this.guardarNuevoTutorAcademicoPractica(this.nuevoTutor).then(r => {
            if (r){
              this.cerrar();
              this.$emit('recargarPractica');
            }
          })
        } else {

        }
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '@/assets/css/colors.scss';
  .group .group-title {
    margin-top: 30px;
    height: auto;
  }
  .btn{
    margin-top: 10px;
    width: 40%;
    margin-left: 140px
  }
  .contenedor-input{
    padding-bottom: 0px;
    margin-bottom: 0px;
  }
  .group .contenedor-data{
    width: 48%;
    margin: 5px;
  }
</style>


// WEBPACK FOOTER //
// src/components/parts/popup-asignar-tutor-academico.vue